import { render, staticRenderFns } from "./TranshipmentQuantityBarChart.vue?vue&type=template&id=08b710c2&scoped=true"
import script from "./TranshipmentQuantityBarChart.vue?vue&type=script&lang=js"
export * from "./TranshipmentQuantityBarChart.vue?vue&type=script&lang=js"
import style0 from "./TranshipmentQuantityBarChart.vue?vue&type=style&index=0&id=08b710c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b710c2",
  null
  
)

export default component.exports